import { Fragment, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import Navigation from 'components/Navigation';
import PageContent from 'components/PageContent';
import Footer from 'components/Footer';
import { FlightTicketProposalStatusEnum } from 'utils/constants.ts';
import ConfirmedFlightOfferPage from 'pages/ConfirmedFlightOffer';
import { useFlightTicketProposal } from 'entities/Flights/sdk';
import { NoFlightOffer } from './NoFlightOfferView';
import { Outlet } from 'react-router-dom';

const FlightOffer = () => {
  const params = useParams<{ flightTicketRequestUUID: string }>();
  const {
    data: flightTicketProposal,
    isLoading: isFlightTicketProposalLoading,
    mutate,
  } = useFlightTicketProposal(params.flightTicketRequestUUID);
  const [currency, setCurrency] = useState<string | null>(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (flightTicketProposal && !initialized.current) {
      setCurrency(flightTicketProposal.default_currency);
      initialized.current = true;
    }
  }, [flightTicketProposal]);

  const isConfirmedFlightOfferPage = flightTicketProposal
    ? [
        FlightTicketProposalStatusEnum.CONFIRMED_AND_PAID,
        FlightTicketProposalStatusEnum.TICKETS_SENT,
        FlightTicketProposalStatusEnum.OPERATED,
      ].includes(flightTicketProposal?.status)
    : false;

  return (
    <Fragment>
      <Navigation />
      {isFlightTicketProposalLoading ? (
        <PageContent>Loading...</PageContent>
      ) : flightTicketProposal ? (
        <Fragment>
          {isConfirmedFlightOfferPage ? (
            <ConfirmedFlightOfferPage
              flightTicketProposal={flightTicketProposal}
              currency={currency}
              setCurrency={setCurrency}
              flightTicketProposalMutate={mutate}
            />
          ) : (
            <Fragment>
              <Outlet
                context={{
                  flightTicketProposal,
                  currency,
                  setCurrency,
                  flightTicketProposalMutate: mutate,
                }}
              />
            </Fragment>
          )}
        </Fragment>
      ) : (
        <NoFlightOffer />
      )}
      <Footer />
    </Fragment>
  );
};

export default FlightOffer;
